import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "message", "title", "confirmButton", "cancelButton", "iconWrap", "iconDestructive", "iconConfirm", "warning"]
  static values = {
    title: { type: String, default: "Confirm Delete" },
    confirmText: { type: String, default: "Delete" },
    cancelText: { type: String, default: "Cancel" }
  }

  connect() {
    this.resolveCallback = null
  }

  show(message, options = {}) {
    return new Promise((resolve) => {
      this.resolveCallback = resolve

      const title = options.title || this.titleValue
      const confirmText = options.confirmText || this.confirmTextValue
      const cancelText = options.cancelText || this.cancelTextValue
      const isDestructive = options.destructive !== false

      if (this.hasTitleTarget) {
        this.titleTarget.textContent = title
      }
      if (this.hasMessageTarget) {
        this.messageTarget.textContent = message
      }

      // Update button text using targets
      if (this.hasConfirmButtonTarget) {
        this.confirmButtonTarget.textContent = confirmText
        if (isDestructive) {
          this.confirmButtonTarget.style.background = 'linear-gradient(180deg, #b91c1c 0%, #7f1d1d 100%)'
          this.confirmButtonTarget.style.borderColor = '#7f1d1d'
          this.confirmButtonTarget.style.boxShadow = '0 1px 3px rgba(127, 29, 29, 0.3), inset 0 1px 0 rgba(255,255,255,0.1)'
        } else {
          this.confirmButtonTarget.style.background = 'linear-gradient(180deg, #d97706 0%, #b45309 100%)'
          this.confirmButtonTarget.style.borderColor = '#b45309'
          this.confirmButtonTarget.style.boxShadow = '0 1px 3px rgba(180, 83, 9, 0.3), inset 0 1px 0 rgba(255,255,255,0.1)'
        }
      }
      if (this.hasCancelButtonTarget) {
        this.cancelButtonTarget.textContent = cancelText
      }

      // Swap the icon (trash vs checkmark) and the icon-wrap color, hide the
      // "cannot be undone" warning when the action is non-destructive.
      if (this.hasIconWrapTarget) {
        if (isDestructive) {
          this.iconWrapTarget.style.background = 'linear-gradient(180deg, #fecaca 0%, #fca5a5 100%)'
          this.iconWrapTarget.style.borderColor = '#f87171'
        } else {
          this.iconWrapTarget.style.background = 'linear-gradient(180deg, #fed7aa 0%, #fdba74 100%)'
          this.iconWrapTarget.style.borderColor = '#fb923c'
        }
      }
      if (this.hasIconDestructiveTarget) this.iconDestructiveTarget.classList.toggle("hidden", !isDestructive)
      if (this.hasIconConfirmTarget) this.iconConfirmTarget.classList.toggle("hidden", isDestructive)
      if (this.hasWarningTarget) this.warningTarget.classList.toggle("hidden", !isDestructive)

      this.dialogTarget.showModal()
      document.body.style.overflow = "hidden"
    })
  }

  confirm() {
    this.close()
    if (this.resolveCallback) {
      this.resolveCallback(true)
      this.resolveCallback = null
    }
  }

  cancel() {
    this.close()
    if (this.resolveCallback) {
      this.resolveCallback(false)
      this.resolveCallback = null
    }
  }

  close() {
    this.dialogTarget.close()
    document.body.style.overflow = ""
  }

  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.cancel()
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape" && this.dialogTarget.open) {
      event.preventDefault()
      this.cancel()
    }
  }
}
